import React, { Component } from 'react';
import {isMobile} from 'react-device-detect';
// import request from 'superagent';
import LoginPage from './LoginPage/LoginPage';
import FactoroilPage from './FactoroilPage/FactoroilPage';
import './App.scss';

/* global sessionStorage */
class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      classPrefix: isMobile ? '__mobile' : '',
      userInfo: {},
    };
  }

  componentWillMount() {
    const id = parseInt(sessionStorage.getItem('login'), 10);
    id &&
        this.getAuthUserData(id).then((res) => this.setState({
          userInfo: res,
        }));
  }

    getAuthUserData = (id) => {

      return new Promise((resolve, err) => {
        // request
        //     .post('http://localhost:8000/users/data')
        //     .set({
        //         Accept: 'application/json',
        //         'Content-Type': 'application/x-www-form-urlencoded',
        //     })
        //     .send({
        //         id: id,
        //     })
        //     .end((err,res) => {
        //         if (res) {
        //             resolve(JSON.parse(res.body.res));
        //         }
        //     });
        const user = {
          companyId: 1,
          email: 'factor@factor.ru',
          id: 1,
          login: 'factor',
          middleName: 'Валерьевич',
          name: 'Александр',
          password: 'factor',
          role: 'factor',
          status: 'enabled',
          surename: 'Довженок',
        };
        this.setState({
          userInfo: user,
        });
        resolve(user);
      });
    }

    handlerLoginAction = (userInfo = {}) => {
      userInfo.id && sessionStorage.setItem('login', userInfo.id);
      this.setState({
        userInfo,
      });
    }

    render() {
      const {classPrefix, userInfo} = this.state;
      const isLogin = parseInt(sessionStorage.getItem('login'), 10);
      const component = (userInfo && userInfo.role) || isLogin > 0?
          (<FactoroilPage
            role={userInfo.role}
            userInfo={userInfo}
            classPrefix={classPrefix} />) :
          (<LoginPage {...this.state}
            handleLoginAction={this.handlerLoginAction} />);

      return (
        <div className={`root${classPrefix}`}>
          {component}
        </div>
      );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js